import { DriverInfo } from './driver-info.model';

export class ConflictGroup {
  constructor(
    public id: string,
    public route: {
      origin: string;
      destination: string;
      departureAtUtc: Date;
      arrivalAtUtc: Date;
    },
    public trainDrivers: DriverInfo[]
  ) {}
}
